import React from 'react';
import ReactDOM from 'react-dom';
import './styles/styles.scss';
import AppRouter from '../src/AppRouter';

ReactDOM.render(<AppRouter />, document.getElementById('root'));